import { FC, ReactNode, useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getUserFromToken } from '../../../modules/user_api';
import AuthService from '../../../services/auth/authService';
import AuthContext from '../../../context/AuthContext';

interface IPrivateRoute {
  excludedRoleLevels?: number[] | null;
  children: (isExcluded: boolean) => JSX.Element;
}

const roleLevelComparator = (oldValue: number, newValue: number) => {
  return oldValue === newValue;
};

const PrivateRoute: FC<IPrivateRoute> = ({ children, excludedRoleLevels = null }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserFromToken());
  }, []);
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userRoleLevel = useSelector((state: any) => state.user.roleLevel, roleLevelComparator);

  // Allow legacy username/password login on app.restoreskills.com for everyone.
  // Realm (Insights) users still sign in through <realm>-app.restoreskills.com;
  // we no longer force-redirect users off the plain host based on realm_name.
  if (!AuthService.authTokenExists()) {
    return <Redirect to="/login" />;
  }
  const excluded = !!excludedRoleLevels && excludedRoleLevels.includes(userRoleLevel);
  return typeof userRoleLevel === 'number' ? children(excluded) : <></>;
};

export const KeycloakPrivateRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth.authenticated) {
      dispatch(getUserFromToken());
    }
  }, []);

  if (auth.authenticated && auth.tokenParsed) {
    return <>{children}</>;
  } else {
    auth.login();
  }

  return <></>;
};

export default PrivateRoute;
